<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>

<div>
<!--   <div *ngIf="signers else loading">
    <h3>{{ 'DOCUMENTS.TEXT.SIGNERS' | translate }}</h3>
    <ul class="singers-list">
        <li *ngFor="let s of signers; let i = index"
            [attr.data-index]="i"
        >
        <app-contract-avatar  [avatarSize]="'36px'" [userGuid]="s.user.guid"  [checkedState]="s.sign"> </app-contract-avatar>
            <div class="signers-item" (click)="helper.openProfileByGuid(s.user.guid)" data-action="openProfile">
                <span [class.blocked_user]="s.user.project_setting.observation_type === 'blocked'"
                      [class.inactive_user]="!s.user.is_active" >
                    {{ helper.fullName(s.user) }}
                </span>
            </div>
              <button (click)="deleteSigner(s)" data-action="deleteSigner" 
                *ngIf="editPermission"
                [disabled]=" s.sign || fileModel.is_approved"
                class="button-icon icononly size-l secondary-button"
                  matTooltip="{{ 'DOCUMENTS.BUTTONS.DELETE_SIGNER' | translate }}" >
                  <mat-icon svgIcon="delete-bin-fill"> </mat-icon>
                </button>
        </li>
    </ul>
    <button class="button-icon size-l primary-button" data-action="addSigner" style="margin-top: 12px; margin-bottom: 12px;"
      [disabled]="fileModel.is_approved"
      (click)="openDialog(addSignersView,500,200)">
      <mat-icon svgIcon="user-add-fill"></mat-icon>
      <span>  {{ 'DOCUMENTS.BUTTONS.ADD_SIGNER' | translate }}   </span>
    </button>
</div> -->


    <div *ngIf="fileModel">
        <h3>
            {{ 'DOCUMENTS.TEXT.VISOR_TYPE' | translate }}:
            {{ (fileModel.type_approve ? ('DOCUMENTS.TEXT.' + fileModel.type_approve) : 'DOCUMENTS.TEXT.NOT_REQUIRED') | translate }}
        </h3>
        <h3>{{ 'DOCUMENTS.TEXT.VISOR' | translate }}</h3>
        <ul class="visors-list">
            <li *ngFor="let visor of visors; let i = index"
                [attr.data-index]="i"
            >
                <app-contract-avatar  [avatarSize]="'36px'" [userGuid]="visor.user.guid"  [checkedState]="visor.sign"> </app-contract-avatar>
                <div (click)="helper.openProfileByGuid(visor.user.guid)" data-action="openProfile">
<!--                     <i [class]="visor.sign ? 'bi bi-eye' : 'bi bi-eye-slash'"
                       [style]="{color : visor.sign ? 'green' : 'red'}"
                       title="{{(visor.sign ? 'DOCUMENTS.TEXT.VISAED' : 'DOCUMENTS.TEXT.WAIT_VISAED') | translate }}"></i> -->
                    <span [class.blocked_user]="visor.user.project_setting.observation_type === 'blocked'"
                          [class.inactive_user]="!visor.user.is_active"
                    >
<!--                     <img *ngIf="visor.user.project_setting.is_project_admin"
                         alt="#"
                         ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                         src="../../../../assets/images/admin.svg"> -->
                        {{ helper.fullName(visor.user) }}
                </span>
                </div>
                <button (click)="deleteVisor(visor)" data-action="deleteVisor" 
                  [disabled]="!editPermission || visor.sign"
                  class="button-icon icononly size-l secondary-button"
                  matTooltip="{{ 'DOCUMENTS.BUTTONS.DELETE_VISOR' | translate }}" >
                  <mat-icon svgIcon="delete-bin-fill"> </mat-icon>
                </button>
<!--                 <i (click)="deleteVisor(visor)"
                   *ngIf="editPermission && !visor.sign"
                   class="icon-delete text-warning"
                   data-action="deleteVisor"
                   ngbTooltip="{{ 'DOCUMENTS.BUTTONS.DELETE_VISOR' | translate }}"
                ></i> -->
            </li>
        </ul>
    </div>

    <div [class.btn-group-sm]="!!collectionId" [class.btn-group]="!!collectionId">
        <div class="visors-buttons" >
            <button class="button-icon size-l secondary-button" data-action="addVisor"
              [disabled]="editPermission && fileModel && fileModel.signed"
              (click)="openDialog(addVisorView,500,200)">
              <mat-icon svgIcon="checkbox-fill"></mat-icon>
              <span>  {{ 'DOCUMENTS.BUTTONS.ADD_VISOR' | translate }}   </span>
            </button>
            <button class="button-icon size-l secondary-button" data-action="addVisorGroup"
              [disabled]="editPermission && fileModel && fileModel.signed"
              (click)="openVisorsModal(addVisorGroupView)">
              <mat-icon svgIcon="checkbox-multiple-fill"></mat-icon>
              <span>  {{ 'DOCUMENTS.BUTTONS.ADD_GROUP_VISOR' | translate }}   </span>
            </button>

        </div>
      <button 
        class="button-icon size-l primary-button" data-action="applyDocument"
         *ngIf="fileModel && currentVisor && !currentVisor.sign"
        (click)="approveDocument()">
        <mat-icon svgIcon="checkbox-multiple-fill"></mat-icon>
        <span>   {{ 'DOCUMENTS.BUTTONS.APPLY' | translate }}  </span>
      </button>
<!--               <button (click)="openPinModal()"
                *ngIf="fileModel && currentVisor && !currentVisor.sign"
                class="btn btn-block mt-1 btn-success"
                data-action="applyDocument"
        >
            {{ 'DOCUMENTS.BUTTONS.APPLY' | translate }}
        </button> -->
    <!--         <button (click)="modalService.openTemplateModal(addVisorView)"
                    [class.mt-3]="!collectionId"
                    [disabled]="editPermission && fileModel && fileModel.signed"
                    class="btn btn-block btn-primary"
                    data-action="addVisor">
                {{ 'DOCUMENTS.BUTTONS.ADD_VISOR' | translate }}
            </button> -->
<!--         <button (click)="openVisorsModal(addVisorGroupView)"
                [class.mt-0]="!!collectionId"
                [class.mt-3]="!collectionId"
                [disabled]="editPermission && fileModel && fileModel.signed"
                class="btn btn-block btn-primary"
                data-action="addVisorGroup">
            {{ 'DOCUMENTS.BUTTONS.ADD_GROUP_VISOR' | translate }}
        </button> -->

    </div>
</div>

<ng-template #addVisorView let-modal>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.ADD_VISOR' | translate }}</h2>
        <select #member class="form-select">
            <option hidden selected value="">{{ 'MODALS.FIELDS.SELECT.VISOR' | translate }}</option>
            <option *ngFor="let member of allMembers" [class.inactive_user]="!member.is_active" [value]="member.guid">
                {{ member.computed_name }}
            </option>
        </select>

        <div *ngIf="!fileModel || (visors && !visors.length)">
            <h2>{{ 'MODALS.FIELDS.VISOR_TYPE' | translate }}</h2>
            <select #approveTypeSelect (change)="approveType = approveTypeSelect.value" class="form-select">
                <option hidden selected value="">{{ 'MODALS.FIELDS.SELECT.VISOR_TYPE.SELECT' | translate }}</option>
                <option value="all">{{ 'MODALS.FIELDS.SELECT.VISOR_TYPE.FULL' | translate }}</option>
                <option value="any">{{ 'MODALS.FIELDS.SELECT.VISOR_TYPE.PARTIALLY' | translate }}</option>
            </select>
        </div>
        <button (click)="addVisor(member.value)" data-action="addVisor"   
          [disabled]="isLockButton || !member.value || (visors && !visors.length && !approveType)"
          class="button-icon size-xl primary-button" style="margin-top: 13px;">
          <mat-icon svgIcon="user-add-fill"> </mat-icon>
          <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.ADD' | translate }}</span>
        </button>
<!--         <button (click)="addVisor(member.value, modal)"
                [disabled]="isLockButton || !member.value || (visors && !visors.length && !approveType)"
                class="btn btn-success mt-2"
                data-action="addVisorButton"
        >
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.ADD' | translate }}</span>
        </button> -->
    </div>
</ng-template>


<ng-template #addVisorGroupView let-modal>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.ADD_VISOR_GROUP' | translate }}</h2>

        <h3>{{ 'MODALS.FIELDS.SELECT.DEPARTMENTS' | translate }}</h3>
        <select [(ngModel)]="selectedDepartmentWithDivisions" class="form-select">
            <option [ngValue]="undefined" hidden>{{ 'MODALS.FIELDS.SELECT.DEPARTMENTS' | translate }}</option>
            <option *ngIf="!allDepartments.length" disabled>{{ 'EMPTY_LISTS.EMPTY' | translate }}</option>
            <option *ngFor="let department of allDepartments"
                    [ngValue]="department"
            >
                {{ department.department_name }}
            </option>
        </select>

        <div *ngIf="selectedDepartmentWithDivisions" style="margin-top: 10px ;">
            <h3>{{ 'MODALS.FIELDS.SELECT.DIVISION' | translate }}</h3>
            <div *ngIf="selectedDepartmentWithDivisions.divisions.length">
                <div *ngFor="let divisionItemCont of selectedDepartmentWithDivisions.divisions"
                     class="division-item">
                    <ng-container
                            *ngTemplateOutlet="division; context: {divisionItem: divisionItemCont}"></ng-container>
                </div>
            </div>
            <div *ngIf="!selectedDepartmentWithDivisions.divisions.length">
                <i><strong>{{ 'EMPTY_LISTS.DIVISIONS' | translate }}</strong></i>
            </div>
        </div>
        <ng-template #division let-divisionItem="divisionItem">
            <div>
                <div class="division-item item-head flex-display justify-content-between">
                    <div>
                        <i (click)="divisionSlider[divisionItem.id] = !divisionSlider[divisionItem.id]"
                           *ngIf="divisionItem.subdivision.length"
                           [class]="divisionSlider[divisionItem.id] ? 'bi bi-caret-down me-1 pointer' : 'bi bi-caret-right me-1 pointer'"
                        ></i>
                        <input (change)="selectedDivisionId = divisionItem.id" class="ms-2 me-1"
                               name="checkDivision" type="radio">
                        <i class="bi-people me-1"
                           ngbTooltip="{{ 'DOCUMENTS.ACCESS.DIVISION' | translate }}"
                        ></i>
                        <span>{{ divisionItem.name }}</span>
                    </div>
                </div>

                <div *ngIf="divisionSlider[divisionItem.id]">
                    <div *ngFor="let divisionItem of divisionItem.subdivision" class="subdivision">
                        <ng-container
                                *ngTemplateOutlet="division; context: {divisionItem: divisionItem}"></ng-container>
                    </div>
                </div>
            </div>
        </ng-template>

        <div *ngIf="!fileModel || (visors && !visors.length)" class="mt-2">
            <h3>{{ 'MODALS.FIELDS.VISOR_TYPE' | translate }}</h3>
            <select #approveTypeSelect (change)="approveType = approveTypeSelect.value" class="form-select">
                <option hidden selected value="">{{ 'MODALS.FIELDS.SELECT.VISOR_TYPE.SELECT' | translate }}</option>
                <option value="all">{{ 'MODALS.FIELDS.SELECT.VISOR_TYPE.FULL' | translate }}</option>
                <option value="any">{{ 'MODALS.FIELDS.SELECT.VISOR_TYPE.PARTIALLY' | translate }}</option>
            </select>
        </div>

        <button (click)="addVisorGroup()" data-action="addVisorButton"   
          [disabled]="isLockButton || !selectedDivisionId"
          class="button-icon size-xl primary-button" style="margin-top: 13px;">
          <mat-icon svgIcon="user-add-fill"> </mat-icon>
          <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.ADD' | translate }}</span>
        </button>
<!--         <button (click)="addVisorGroup(modal)"
                [disabled]="isLockButton || !selectedDivisionId"
                class="btn btn-success mt-2"
                data-action="addVisorButton"
        >
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.ADD' | translate }}</span>
        </button> -->
    </div>
</ng-template>
